import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { Grid2 } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

function WelcomeTour({ setTutorialStep, setDialogOpen }) {
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    setDialogOpen(false);
  };

  return (
    <Dialog
      sx={{ width: '80%', margin: 'auto' }}
      open={open}
      onClose={handleClose}
      PaperProps={{ style: { maxWidth: 'none' } }}
    >
      <Box style={{ padding: '30px' }}>
        <DialogTitle style={{ marginBottom: '15px' }}>
          <Grid2 container direction="column" alignItems="center">
            <Grid2 item style={{ marginBottom: '8px' }}>
              <Typography
                component="h3"
                style={{
                  fontFamily: 'Montserrat',
                  fontWeight: '600',
                  fontSize: '1.2rem',
                }}
              >
                Bem vindo(a) ao
              </Typography>
            </Grid2>
            <Grid2 item>
              <img src="/logo-full-color.svg" alt="sioon logo" />
            </Grid2>
          </Grid2>
        </DialogTitle>
        <Typography
          paragraph
          style={{ fontFamily: 'Montserrat', fontSize: '1rem' }}
        >
          O sistema SIOON reúne toda a administração das suas obras em um só
          lugar, tornando tudo pesquisável e disponível para você ter acesso
          imediatamente.
        </Typography>
        <Typography
          paragraph
          style={{ fontFamily: 'Montserrat', fontSize: '1rem' }}
        >
          Nosso objetivo é tornar sua vida profissional mais simples, mais
          agradável e mais produtiva.
        </Typography>
        <Grid2 container direction="column" alignItems="center">
          <Grid2 item style={{ margin: '25px 0 15px 0' }}>
            <Button
              variant="contained"
              color="primary"
              style={{ fontSize: '1.2rem', padding: '7px 25px' }}
              onClick={() => setTutorialStep((step) => step + 1)}
            >
              INICIAR TOUR RÁPIDO
            </Button>
          </Grid2>
          <Grid2 item>
            <Button
              variant="text"
              onClick={handleClose}
              color="inherit"
              style={{ transform: 'revert' }}
            >
              Pular Tour
            </Button>
          </Grid2>
        </Grid2>
      </Box>
    </Dialog>
  );
}

WelcomeTour.propTypes = {
  setTutorialStep: PropTypes.func.isRequired,
  setDialogOpen: PropTypes.func.isRequired,
};

export default WelcomeTour;
